import { useLocation } from "react-router";

export function useLastUrlPart(): string {
  const location = useLocation();
  const urlParts = location.pathname.split("/");
  return urlParts[urlParts.length - 1];
}
